import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AgrFilterModule, AgrNotificationEmptyModule, AgrPageDetailModule, AgrPageToolbarModule, AgrPrintPageModule } from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrTableModule } from '@next/core-lib/table';
import { TableV2Module } from '@next/core-lib/table-v2';

import { provideEffects } from '@ngrx/effects';

import { provideState } from '@ngrx/store';

// eslint-disable-next-line max-len
import { ConfirmFertilisersOrderDialogComponent } from './components/confirm-fertilisers-order-dialog/confirm-fertilisers-order-dialog/confirm-fertilisers-order-dialog.component';
import { OverviewTableComponent } from './components/overview-table/overview-table.component';
import { OrderReceiptComponent } from './components/overview-table/report/order-receipt.component';
import { FertilisersOverviewComponent } from './fertilisers-overview.component';
import { ArticleNameTranslationPipe } from './pipes/article-name-translation.pipe';
import { CropAidArticlesFilterPipe } from './pipes/filter-crop-aid-articles.pipe';
import { ReportsModule } from '../reports/reports.module';
import { SharedModule } from '../shared/shared.module';
import { FertilisersEffects } from './store/effects/fertilisers.effects';

import { fertilisersReducer } from './store/reducers/fertilisers.reducer';

@NgModule({
  declarations: [
    CropAidArticlesFilterPipe,
    ArticleNameTranslationPipe,
    FertilisersOverviewComponent,
    OverviewTableComponent,
    OrderReceiptComponent,
    ConfirmFertilisersOrderDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AgrDialogModule,
    AgrFormModule,
    AgrPageToolbarModule,
    AgrFilterModule,
    AgrNotificationEmptyModule,
    AgrTableModule,
    AgrPageDetailModule,
    AgrPrintPageModule,
    TableV2Module,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatDividerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatTableModule,
    MatTooltipModule,
    MatButtonModule,
    RouterModule,
    ReportsModule,
    MatDatepickerModule,
  ],
  providers: [provideState('fertilisers', fertilisersReducer), provideEffects([FertilisersEffects])],
})
export class FertilisersOverviewModule {}
